import { getIdAndContentTypeFromTopics } from '../../utils'
import { bulkApprove } from './service'
// eslint-disable-next-line import/no-internal-modules
import { BulkActionComponentProps } from '@insided/deprecated-control/overview'
// eslint-disable-next-line import/no-internal-modules
import Icon from '@insided/deprecated-preact-components/assets'
// eslint-disable-next-line import/no-internal-modules
import ButtonControl from '@insided/deprecated-preact-components/button-control'

const Approve = ({
  performBulkAction
}: BulkActionComponentProps) => (
  <ButtonControl
    title={
      <div>
        <Icon icon='checkmark' width={16} height={16} />
        Approve
      </div>
    }
    size='medium'
    newStyle
    variant='approval'
    // eslint-disable-next-line @gorazdo/preact/prefer-classname
    class='qa-mark-approve'
    onClick={() => {
      return performBulkAction({
        onClick: async (topics: []) => await bulkApprove(getIdAndContentTypeFromTopics(topics)),
        successMessage: 'Item(s) successfully approved.'
      })
    }}
  />
)

export default Approve
